import { Component,OnInit, OnDestroy, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {

    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    show = false;
    isIframe = false;

    constructor(private ref: ChangeDetectorRef) {
        this.loadingSubject.next(false);
        this.ref.markForCheck();
    }

    ngOnInit(): void {
        this.isIframe = window !== window.parent && !window.opener;
        this.loadingSubject.next(false);
    }
    ngOnDestroy(): void {
        this.loadingSubject.next(false);
    }

    ngAfterViewChecked(): void {
        this.loading$ = this.loading$ || null;
        if (this.loading$) {
            this.loading$.subscribe(result => {
                this.show = result || false;
            });
        }

        this.ref.detectChanges();
    }

    startLoading(showLoading: boolean) {
        this.loadingSubject.next(showLoading);
    }
}
